import { contextExchange } from '@urql/exchange-context';
import { getOperationName } from 'urql';

export const operationNameExchange = contextExchange({
  getContext(op) {
    const opName = getOperationName(op.query);
    const url = op.context.url + '/' + opName;

    return {
      ...op.context,
      url,
    };
  },
});
